module.exports = __webpack_public_path__ + "img/end-of-month-left.0ea1fc17.svg";